<li class="event-item">
    <a href="{{ item?.EventURL }}" target="_blank">
        <div class="event-content">
            <div class="event-content-item date-range">{{ item?.EventStartDate | date }}</div>
            <span class="event-content-item event-title"
                 [matTooltip]="item?.TitleTooltip"
                 matTooltipPosition="above"
                 [innerHtml]="item?.Title"></span>
            <div class="event-content-item event-booth">{{ item?.Booth }}</div>
            <div class="event-content-item event-location">{{ item?.EventLocation }}, {{ item?.CountryCode }}</div>
        </div>
    </a>
</li>
